"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostAccounts = exports.DelegatorUnbondingEpochEntry = exports.UnbondingEpochCValue = exports.TransientUndelegationTransfer = exports.IBCAmountTransientStore = exports.HostChainRewardAddress = exports.UndelegationEntry = exports.HostAccountUndelegation = exports.HostAccountDelegation = exports.DelegationState = exports.HostChainParams = exports.PstakeParams = exports.AllowListedValidator = exports.AllowListedValidators = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const timestamp_1 = require("../../../google/protobuf/timestamp");
const binary_1 = require("../../../binary");
const helpers_1 = require("../../../helpers");
exports.protobufPackage = "pstake.lscosmos.v1beta1";
function createBaseAllowListedValidators() {
    return {
        allowListedValidators: [],
    };
}
exports.AllowListedValidators = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.allowListedValidators) {
            exports.AllowListedValidator.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllowListedValidators();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowListedValidators.push(exports.AllowListedValidator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseAllowListedValidators();
        if (Array.isArray(object?.allowListedValidators))
            obj.allowListedValidators = object.allowListedValidators.map((e) => exports.AllowListedValidator.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.allowListedValidators) {
            obj.allowListedValidators = message.allowListedValidators.map((e) => e ? exports.AllowListedValidator.toJSON(e) : undefined);
        }
        else {
            obj.allowListedValidators = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAllowListedValidators();
        message.allowListedValidators =
            object.allowListedValidators?.map((e) => exports.AllowListedValidator.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAllowListedValidator() {
    return {
        validatorAddress: "",
        targetWeight: "",
    };
}
exports.AllowListedValidator = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (message.targetWeight !== "") {
            writer.uint32(18).string(message.targetWeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAllowListedValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.targetWeight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseAllowListedValidator();
        if ((0, helpers_1.isSet)(object.validatorAddress))
            obj.validatorAddress = String(object.validatorAddress);
        if ((0, helpers_1.isSet)(object.targetWeight))
            obj.targetWeight = String(object.targetWeight);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.targetWeight !== undefined && (obj.targetWeight = message.targetWeight);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseAllowListedValidator();
        message.validatorAddress = object.validatorAddress ?? "";
        message.targetWeight = object.targetWeight ?? "";
        return message;
    },
};
function createBasePstakeParams() {
    return {
        pstakeDepositFee: "",
        pstakeRestakeFee: "",
        pstakeUnstakeFee: "",
        pstakeRedemptionFee: "",
        pstakeFeeAddress: "",
    };
}
exports.PstakeParams = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.pstakeDepositFee !== "") {
            writer.uint32(10).string(message.pstakeDepositFee);
        }
        if (message.pstakeRestakeFee !== "") {
            writer.uint32(18).string(message.pstakeRestakeFee);
        }
        if (message.pstakeUnstakeFee !== "") {
            writer.uint32(26).string(message.pstakeUnstakeFee);
        }
        if (message.pstakeRedemptionFee !== "") {
            writer.uint32(34).string(message.pstakeRedemptionFee);
        }
        if (message.pstakeFeeAddress !== "") {
            writer.uint32(42).string(message.pstakeFeeAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePstakeParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pstakeDepositFee = reader.string();
                    break;
                case 2:
                    message.pstakeRestakeFee = reader.string();
                    break;
                case 3:
                    message.pstakeUnstakeFee = reader.string();
                    break;
                case 4:
                    message.pstakeRedemptionFee = reader.string();
                    break;
                case 5:
                    message.pstakeFeeAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBasePstakeParams();
        if ((0, helpers_1.isSet)(object.pstakeDepositFee))
            obj.pstakeDepositFee = String(object.pstakeDepositFee);
        if ((0, helpers_1.isSet)(object.pstakeRestakeFee))
            obj.pstakeRestakeFee = String(object.pstakeRestakeFee);
        if ((0, helpers_1.isSet)(object.pstakeUnstakeFee))
            obj.pstakeUnstakeFee = String(object.pstakeUnstakeFee);
        if ((0, helpers_1.isSet)(object.pstakeRedemptionFee))
            obj.pstakeRedemptionFee = String(object.pstakeRedemptionFee);
        if ((0, helpers_1.isSet)(object.pstakeFeeAddress))
            obj.pstakeFeeAddress = String(object.pstakeFeeAddress);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.pstakeDepositFee !== undefined && (obj.pstakeDepositFee = message.pstakeDepositFee);
        message.pstakeRestakeFee !== undefined && (obj.pstakeRestakeFee = message.pstakeRestakeFee);
        message.pstakeUnstakeFee !== undefined && (obj.pstakeUnstakeFee = message.pstakeUnstakeFee);
        message.pstakeRedemptionFee !== undefined && (obj.pstakeRedemptionFee = message.pstakeRedemptionFee);
        message.pstakeFeeAddress !== undefined && (obj.pstakeFeeAddress = message.pstakeFeeAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBasePstakeParams();
        message.pstakeDepositFee = object.pstakeDepositFee ?? "";
        message.pstakeRestakeFee = object.pstakeRestakeFee ?? "";
        message.pstakeUnstakeFee = object.pstakeUnstakeFee ?? "";
        message.pstakeRedemptionFee = object.pstakeRedemptionFee ?? "";
        message.pstakeFeeAddress = object.pstakeFeeAddress ?? "";
        return message;
    },
};
function createBaseHostChainParams() {
    return {
        chainID: "",
        connectionID: "",
        transferChannel: "",
        transferPort: "",
        baseDenom: "",
        mintDenom: "",
        minDeposit: "",
        pstakeParams: exports.PstakeParams.fromPartial({}),
    };
}
exports.HostChainParams = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        if (message.connectionID !== "") {
            writer.uint32(18).string(message.connectionID);
        }
        if (message.transferChannel !== "") {
            writer.uint32(26).string(message.transferChannel);
        }
        if (message.transferPort !== "") {
            writer.uint32(34).string(message.transferPort);
        }
        if (message.baseDenom !== "") {
            writer.uint32(42).string(message.baseDenom);
        }
        if (message.mintDenom !== "") {
            writer.uint32(50).string(message.mintDenom);
        }
        if (message.minDeposit !== "") {
            writer.uint32(58).string(message.minDeposit);
        }
        if (message.pstakeParams !== undefined) {
            exports.PstakeParams.encode(message.pstakeParams, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostChainParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                case 2:
                    message.connectionID = reader.string();
                    break;
                case 3:
                    message.transferChannel = reader.string();
                    break;
                case 4:
                    message.transferPort = reader.string();
                    break;
                case 5:
                    message.baseDenom = reader.string();
                    break;
                case 6:
                    message.mintDenom = reader.string();
                    break;
                case 7:
                    message.minDeposit = reader.string();
                    break;
                case 8:
                    message.pstakeParams = exports.PstakeParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostChainParams();
        if ((0, helpers_1.isSet)(object.chainID))
            obj.chainID = String(object.chainID);
        if ((0, helpers_1.isSet)(object.connectionID))
            obj.connectionID = String(object.connectionID);
        if ((0, helpers_1.isSet)(object.transferChannel))
            obj.transferChannel = String(object.transferChannel);
        if ((0, helpers_1.isSet)(object.transferPort))
            obj.transferPort = String(object.transferPort);
        if ((0, helpers_1.isSet)(object.baseDenom))
            obj.baseDenom = String(object.baseDenom);
        if ((0, helpers_1.isSet)(object.mintDenom))
            obj.mintDenom = String(object.mintDenom);
        if ((0, helpers_1.isSet)(object.minDeposit))
            obj.minDeposit = String(object.minDeposit);
        if ((0, helpers_1.isSet)(object.pstakeParams))
            obj.pstakeParams = exports.PstakeParams.fromJSON(object.pstakeParams);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        message.connectionID !== undefined && (obj.connectionID = message.connectionID);
        message.transferChannel !== undefined && (obj.transferChannel = message.transferChannel);
        message.transferPort !== undefined && (obj.transferPort = message.transferPort);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.minDeposit !== undefined && (obj.minDeposit = message.minDeposit);
        message.pstakeParams !== undefined &&
            (obj.pstakeParams = message.pstakeParams ? exports.PstakeParams.toJSON(message.pstakeParams) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostChainParams();
        message.chainID = object.chainID ?? "";
        message.connectionID = object.connectionID ?? "";
        message.transferChannel = object.transferChannel ?? "";
        message.transferPort = object.transferPort ?? "";
        message.baseDenom = object.baseDenom ?? "";
        message.mintDenom = object.mintDenom ?? "";
        message.minDeposit = object.minDeposit ?? "";
        if (object.pstakeParams !== undefined && object.pstakeParams !== null) {
            message.pstakeParams = exports.PstakeParams.fromPartial(object.pstakeParams);
        }
        return message;
    },
};
function createBaseDelegationState() {
    return {
        hostDelegationAccountBalance: [],
        hostChainDelegationAddress: "",
        hostAccountDelegations: [],
        hostAccountUndelegations: [],
    };
}
exports.DelegationState = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.hostDelegationAccountBalance) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.hostChainDelegationAddress !== "") {
            writer.uint32(18).string(message.hostChainDelegationAddress);
        }
        for (const v of message.hostAccountDelegations) {
            exports.HostAccountDelegation.encode(v, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.hostAccountUndelegations) {
            exports.HostAccountUndelegation.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegationState();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hostDelegationAccountBalance.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.hostChainDelegationAddress = reader.string();
                    break;
                case 3:
                    message.hostAccountDelegations.push(exports.HostAccountDelegation.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.hostAccountUndelegations.push(exports.HostAccountUndelegation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseDelegationState();
        if (Array.isArray(object?.hostDelegationAccountBalance))
            obj.hostDelegationAccountBalance = object.hostDelegationAccountBalance.map((e) => coin_1.Coin.fromJSON(e));
        if ((0, helpers_1.isSet)(object.hostChainDelegationAddress))
            obj.hostChainDelegationAddress = String(object.hostChainDelegationAddress);
        if (Array.isArray(object?.hostAccountDelegations))
            obj.hostAccountDelegations = object.hostAccountDelegations.map((e) => exports.HostAccountDelegation.fromJSON(e));
        if (Array.isArray(object?.hostAccountUndelegations))
            obj.hostAccountUndelegations = object.hostAccountUndelegations.map((e) => exports.HostAccountUndelegation.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.hostDelegationAccountBalance) {
            obj.hostDelegationAccountBalance = message.hostDelegationAccountBalance.map((e) => e ? coin_1.Coin.toJSON(e) : undefined);
        }
        else {
            obj.hostDelegationAccountBalance = [];
        }
        message.hostChainDelegationAddress !== undefined &&
            (obj.hostChainDelegationAddress = message.hostChainDelegationAddress);
        if (message.hostAccountDelegations) {
            obj.hostAccountDelegations = message.hostAccountDelegations.map((e) => e ? exports.HostAccountDelegation.toJSON(e) : undefined);
        }
        else {
            obj.hostAccountDelegations = [];
        }
        if (message.hostAccountUndelegations) {
            obj.hostAccountUndelegations = message.hostAccountUndelegations.map((e) => e ? exports.HostAccountUndelegation.toJSON(e) : undefined);
        }
        else {
            obj.hostAccountUndelegations = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegationState();
        message.hostDelegationAccountBalance =
            object.hostDelegationAccountBalance?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        message.hostChainDelegationAddress = object.hostChainDelegationAddress ?? "";
        message.hostAccountDelegations =
            object.hostAccountDelegations?.map((e) => exports.HostAccountDelegation.fromPartial(e)) || [];
        message.hostAccountUndelegations =
            object.hostAccountUndelegations?.map((e) => exports.HostAccountUndelegation.fromPartial(e)) || [];
        return message;
    },
};
function createBaseHostAccountDelegation() {
    return {
        validatorAddress: "",
        amount: coin_1.Coin.fromPartial({}),
    };
}
exports.HostAccountDelegation = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostAccountDelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostAccountDelegation();
        if ((0, helpers_1.isSet)(object.validatorAddress))
            obj.validatorAddress = String(object.validatorAddress);
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = coin_1.Coin.fromJSON(object.amount);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostAccountDelegation();
        message.validatorAddress = object.validatorAddress ?? "";
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin_1.Coin.fromPartial(object.amount);
        }
        return message;
    },
};
function createBaseHostAccountUndelegation() {
    return {
        epochNumber: BigInt(0),
        totalUndelegationAmount: coin_1.Coin.fromPartial({}),
        completionTime: timestamp_1.Timestamp.fromPartial({}),
        undelegationEntries: [],
    };
}
exports.HostAccountUndelegation = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(8).int64(message.epochNumber);
        }
        if (message.totalUndelegationAmount !== undefined) {
            coin_1.Coin.encode(message.totalUndelegationAmount, writer.uint32(18).fork()).ldelim();
        }
        if (message.completionTime !== undefined) {
            timestamp_1.Timestamp.encode(message.completionTime, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.undelegationEntries) {
            exports.UndelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostAccountUndelegation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.epochNumber = reader.int64();
                    break;
                case 2:
                    message.totalUndelegationAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.completionTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.undelegationEntries.push(exports.UndelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostAccountUndelegation();
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        if ((0, helpers_1.isSet)(object.totalUndelegationAmount))
            obj.totalUndelegationAmount = coin_1.Coin.fromJSON(object.totalUndelegationAmount);
        if ((0, helpers_1.isSet)(object.completionTime))
            obj.completionTime = (0, helpers_1.fromJsonTimestamp)(object.completionTime);
        if (Array.isArray(object?.undelegationEntries))
            obj.undelegationEntries = object.undelegationEntries.map((e) => exports.UndelegationEntry.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        message.totalUndelegationAmount !== undefined &&
            (obj.totalUndelegationAmount = message.totalUndelegationAmount
                ? coin_1.Coin.toJSON(message.totalUndelegationAmount)
                : undefined);
        message.completionTime !== undefined &&
            (obj.completionTime = (0, helpers_1.fromTimestamp)(message.completionTime).toISOString());
        if (message.undelegationEntries) {
            obj.undelegationEntries = message.undelegationEntries.map((e) => e ? exports.UndelegationEntry.toJSON(e) : undefined);
        }
        else {
            obj.undelegationEntries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostAccountUndelegation();
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        if (object.totalUndelegationAmount !== undefined && object.totalUndelegationAmount !== null) {
            message.totalUndelegationAmount = coin_1.Coin.fromPartial(object.totalUndelegationAmount);
        }
        if (object.completionTime !== undefined && object.completionTime !== null) {
            message.completionTime = timestamp_1.Timestamp.fromPartial(object.completionTime);
        }
        message.undelegationEntries =
            object.undelegationEntries?.map((e) => exports.UndelegationEntry.fromPartial(e)) || [];
        return message;
    },
};
function createBaseUndelegationEntry() {
    return {
        validatorAddress: "",
        amount: coin_1.Coin.fromPartial({}),
    };
}
exports.UndelegationEntry = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.validatorAddress !== "") {
            writer.uint32(10).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUndelegationEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseUndelegationEntry();
        if ((0, helpers_1.isSet)(object.validatorAddress))
            obj.validatorAddress = String(object.validatorAddress);
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = coin_1.Coin.fromJSON(object.amount);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUndelegationEntry();
        message.validatorAddress = object.validatorAddress ?? "";
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin_1.Coin.fromPartial(object.amount);
        }
        return message;
    },
};
function createBaseHostChainRewardAddress() {
    return {
        address: "",
    };
}
exports.HostChainRewardAddress = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostChainRewardAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostChainRewardAddress();
        if ((0, helpers_1.isSet)(object.address))
            obj.address = String(object.address);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostChainRewardAddress();
        message.address = object.address ?? "";
        return message;
    },
};
function createBaseIBCAmountTransientStore() {
    return {
        iBCTransfer: [],
        iCADelegate: coin_1.Coin.fromPartial({}),
        undelegatonCompleteIBCTransfer: [],
    };
}
exports.IBCAmountTransientStore = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.iBCTransfer) {
            coin_1.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.iCADelegate !== undefined) {
            coin_1.Coin.encode(message.iCADelegate, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.undelegatonCompleteIBCTransfer) {
            exports.TransientUndelegationTransfer.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseIBCAmountTransientStore();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.iBCTransfer.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.iCADelegate = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.undelegatonCompleteIBCTransfer.push(exports.TransientUndelegationTransfer.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseIBCAmountTransientStore();
        if (Array.isArray(object?.iBCTransfer))
            obj.iBCTransfer = object.iBCTransfer.map((e) => coin_1.Coin.fromJSON(e));
        if ((0, helpers_1.isSet)(object.iCADelegate))
            obj.iCADelegate = coin_1.Coin.fromJSON(object.iCADelegate);
        if (Array.isArray(object?.undelegatonCompleteIBCTransfer))
            obj.undelegatonCompleteIBCTransfer = object.undelegatonCompleteIBCTransfer.map((e) => exports.TransientUndelegationTransfer.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.iBCTransfer) {
            obj.iBCTransfer = message.iBCTransfer.map((e) => (e ? coin_1.Coin.toJSON(e) : undefined));
        }
        else {
            obj.iBCTransfer = [];
        }
        message.iCADelegate !== undefined &&
            (obj.iCADelegate = message.iCADelegate ? coin_1.Coin.toJSON(message.iCADelegate) : undefined);
        if (message.undelegatonCompleteIBCTransfer) {
            obj.undelegatonCompleteIBCTransfer = message.undelegatonCompleteIBCTransfer.map((e) => e ? exports.TransientUndelegationTransfer.toJSON(e) : undefined);
        }
        else {
            obj.undelegatonCompleteIBCTransfer = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseIBCAmountTransientStore();
        message.iBCTransfer = object.iBCTransfer?.map((e) => coin_1.Coin.fromPartial(e)) || [];
        if (object.iCADelegate !== undefined && object.iCADelegate !== null) {
            message.iCADelegate = coin_1.Coin.fromPartial(object.iCADelegate);
        }
        message.undelegatonCompleteIBCTransfer =
            object.undelegatonCompleteIBCTransfer?.map((e) => exports.TransientUndelegationTransfer.fromPartial(e)) || [];
        return message;
    },
};
function createBaseTransientUndelegationTransfer() {
    return {
        epochNumber: BigInt(0),
        amountUnbonded: coin_1.Coin.fromPartial({}),
    };
}
exports.TransientUndelegationTransfer = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(8).int64(message.epochNumber);
        }
        if (message.amountUnbonded !== undefined) {
            coin_1.Coin.encode(message.amountUnbonded, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTransientUndelegationTransfer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.epochNumber = reader.int64();
                    break;
                case 2:
                    message.amountUnbonded = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseTransientUndelegationTransfer();
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        if ((0, helpers_1.isSet)(object.amountUnbonded))
            obj.amountUnbonded = coin_1.Coin.fromJSON(object.amountUnbonded);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        message.amountUnbonded !== undefined &&
            (obj.amountUnbonded = message.amountUnbonded ? coin_1.Coin.toJSON(message.amountUnbonded) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseTransientUndelegationTransfer();
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        if (object.amountUnbonded !== undefined && object.amountUnbonded !== null) {
            message.amountUnbonded = coin_1.Coin.fromPartial(object.amountUnbonded);
        }
        return message;
    },
};
function createBaseUnbondingEpochCValue() {
    return {
        epochNumber: BigInt(0),
        sTKBurn: coin_1.Coin.fromPartial({}),
        amountUnbonded: coin_1.Coin.fromPartial({}),
        isMatured: false,
        isFailed: false,
    };
}
exports.UnbondingEpochCValue = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(8).int64(message.epochNumber);
        }
        if (message.sTKBurn !== undefined) {
            coin_1.Coin.encode(message.sTKBurn, writer.uint32(18).fork()).ldelim();
        }
        if (message.amountUnbonded !== undefined) {
            coin_1.Coin.encode(message.amountUnbonded, writer.uint32(26).fork()).ldelim();
        }
        if (message.isMatured === true) {
            writer.uint32(32).bool(message.isMatured);
        }
        if (message.isFailed === true) {
            writer.uint32(40).bool(message.isFailed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnbondingEpochCValue();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.epochNumber = reader.int64();
                    break;
                case 2:
                    message.sTKBurn = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.amountUnbonded = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.isMatured = reader.bool();
                    break;
                case 5:
                    message.isFailed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseUnbondingEpochCValue();
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        if ((0, helpers_1.isSet)(object.sTKBurn))
            obj.sTKBurn = coin_1.Coin.fromJSON(object.sTKBurn);
        if ((0, helpers_1.isSet)(object.amountUnbonded))
            obj.amountUnbonded = coin_1.Coin.fromJSON(object.amountUnbonded);
        if ((0, helpers_1.isSet)(object.isMatured))
            obj.isMatured = Boolean(object.isMatured);
        if ((0, helpers_1.isSet)(object.isFailed))
            obj.isFailed = Boolean(object.isFailed);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        message.sTKBurn !== undefined &&
            (obj.sTKBurn = message.sTKBurn ? coin_1.Coin.toJSON(message.sTKBurn) : undefined);
        message.amountUnbonded !== undefined &&
            (obj.amountUnbonded = message.amountUnbonded ? coin_1.Coin.toJSON(message.amountUnbonded) : undefined);
        message.isMatured !== undefined && (obj.isMatured = message.isMatured);
        message.isFailed !== undefined && (obj.isFailed = message.isFailed);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUnbondingEpochCValue();
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        if (object.sTKBurn !== undefined && object.sTKBurn !== null) {
            message.sTKBurn = coin_1.Coin.fromPartial(object.sTKBurn);
        }
        if (object.amountUnbonded !== undefined && object.amountUnbonded !== null) {
            message.amountUnbonded = coin_1.Coin.fromPartial(object.amountUnbonded);
        }
        message.isMatured = object.isMatured ?? false;
        message.isFailed = object.isFailed ?? false;
        return message;
    },
};
function createBaseDelegatorUnbondingEpochEntry() {
    return {
        delegatorAddress: "",
        epochNumber: BigInt(0),
        amount: coin_1.Coin.fromPartial({}),
    };
}
exports.DelegatorUnbondingEpochEntry = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(16).int64(message.epochNumber);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDelegatorUnbondingEpochEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.epochNumber = reader.int64();
                    break;
                case 3:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseDelegatorUnbondingEpochEntry();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = coin_1.Coin.fromJSON(object.amount);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDelegatorUnbondingEpochEntry();
        message.delegatorAddress = object.delegatorAddress ?? "";
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin_1.Coin.fromPartial(object.amount);
        }
        return message;
    },
};
function createBaseHostAccounts() {
    return {
        delegatorAccountOwnerID: "",
        rewardsAccountOwnerID: "",
    };
}
exports.HostAccounts = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAccountOwnerID !== "") {
            writer.uint32(10).string(message.delegatorAccountOwnerID);
        }
        if (message.rewardsAccountOwnerID !== "") {
            writer.uint32(18).string(message.rewardsAccountOwnerID);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostAccounts();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAccountOwnerID = reader.string();
                    break;
                case 2:
                    message.rewardsAccountOwnerID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostAccounts();
        if ((0, helpers_1.isSet)(object.delegatorAccountOwnerID))
            obj.delegatorAccountOwnerID = String(object.delegatorAccountOwnerID);
        if ((0, helpers_1.isSet)(object.rewardsAccountOwnerID))
            obj.rewardsAccountOwnerID = String(object.rewardsAccountOwnerID);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAccountOwnerID !== undefined &&
            (obj.delegatorAccountOwnerID = message.delegatorAccountOwnerID);
        message.rewardsAccountOwnerID !== undefined &&
            (obj.rewardsAccountOwnerID = message.rewardsAccountOwnerID);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostAccounts();
        message.delegatorAccountOwnerID = object.delegatorAccountOwnerID ?? "";
        message.rewardsAccountOwnerID = object.rewardsAccountOwnerID ?? "";
        return message;
    },
};
//# sourceMappingURL=lscosmos.js.map